// extracted by mini-css-extract-plugin
module.exports = {"heading":"home-page_heading__Z3lwh"};